import React__default from 'react';
import { __extends, __spreadArrays } from '../../_virtual/_tslib.js';
import withChat from '../Provider/withChat.js';
import { Waypoint } from 'react-waypoint';
import { ScrollConsumer } from '../Scrollable/index.js';
import MessageRow from '../../components/MessageRow/index.js';
import AudioMessage from '../../components/messages/AudioMessage/index.js';
import ErrorMessage from '../../components/messages/ErrorMessage/index.js';
import CarouselMessage from '../../components/messages/CarouselMessage/index.js';
import ContactCollectionMessage from '../../components/messages/ContactCollectionMessage/index.js';
import CuratedOrderListMessage from '../../components/messages/CuratedOrderListMessage/index.js';
import CustomExpertCuratedOrderMessage from '../../components/messages/CustomExpertCuratedOrderMessage/index.js';
import ExpertJoinedMessage from '../../components/messages/ExpertJoinedMessage/index.js';
import FeedbackRequestedMessage from '../../components/messages/FeedbackRequestMessage/index.js';
import FileMessage from '../../components/messages/FileMessage/index.js';
import GuestChatCreateMessage from '../../components/messages/GuestChatCreateMessage/index.js';
import HowCuratedWorksMessage from '../../components/messages/HowCuratedWorksMessage/index.js';
import HyperLinkTextMessage from '../../components/messages/HyperLinkTextMessage/index.js';
import ImageMessage from '../../components/messages/ImageMessage/index.js';
import InterestedInOrderMessage from '../../components/messages/InterestedInOrderMessage/index.js';
import PaymentVerificationMessage from '../../components/messages/PaymentVerificationMessage/index.js';
import ProductCurationMessage from '../../components/messages/ProductCurationMessage/index.js';
import ProductQuizMessage from '../../components/messages/ProductQuizMessage/index.js';
import ReferralMessage from '../../components/messages/ReferralMessage/index.js';
import RequestConfirmationMessage from '../../components/messages/RequestConfirmationMessage/index.js';
import ServiceCurationMessage from '../../components/messages/ServiceCurationMessage/index.js';
import SellablePriceMatchMessage from '../../components/messages/SellablePriceMatchMessage/index.js';
import SimpleCuratedOrderMessage from '../../components/messages/SimpleCuratedOrderMessage/index.js';
import TextMessage from '../../components/messages/TextMessage/index.js';
import VideoMessage from '../../components/messages/VideoMessage/index.js';
import ConversationStarterMessage from '../../components/messages/ConversationStarterMessage/index.js';

var MessageContainer =
/** @class */
function (_super) {
  __extends(MessageContainer, _super);

  function MessageContainer(props) {
    var _this = _super.call(this, props) || this;
    /**
     * A list of React components available to render messages. Each message component must
     *   implement a static `handlesMessage` method that determines whether it can render
     *   a given message.
     *
     * Note: Order matters! The first component that can handle a message is used.
     */


    _this.coreMessages = [ImageMessage, VideoMessage, AudioMessage, CarouselMessage, TextMessage, HyperLinkTextMessage, FileMessage, ErrorMessage];
    /**
     * A list of rich card messages to render `rich` content. Order isn't important here
     *    as cards are selected via the `MessageRichCardType` enum.
     */

    _this.richCardMessages = [ContactCollectionMessage, ConversationStarterMessage, CuratedOrderListMessage, CustomExpertCuratedOrderMessage, ExpertJoinedMessage, FeedbackRequestedMessage, GuestChatCreateMessage, HowCuratedWorksMessage, PaymentVerificationMessage, ProductCurationMessage, ReferralMessage, SellablePriceMatchMessage, ServiceCurationMessage, SimpleCuratedOrderMessage, ProductQuizMessage, RequestConfirmationMessage, InterestedInOrderMessage];
    _this.state = {
      isRead: props.message.read
    };
    _this.handlePositionChange = _this.handlePositionChange.bind(_this);
    _this.handleMessageRead = _this.handleMessageRead.bind(_this);
    return _this;
  }

  MessageContainer.prototype.handleMessageRead = function () {
    this.setState({
      isRead: true
    });
  };

  MessageContainer.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.enableReadReceipts !== this.props.enableReadReceipts) {
      this.props.message.conversation.markConversationRead(this.props.message.messageId);
    }
  };

  MessageContainer.prototype.componentDidMount = function () {
    var _this = this;

    if (!this.props.message.initialized) {
      this.props.message.once('initialized', function () {
        return _this.forceUpdate();
      }, this);
    }

    this.props.message.on('read', this.handleMessageRead);
  };

  MessageContainer.prototype.componentWillUnmount = function () {
    this.props.message.off('initialized', undefined, this);
    this.props.message.off('read', this.handleMessageRead);
  };

  MessageContainer.prototype.handlePositionChange = function (_a) {
    var _this = this;

    var currentPosition = _a.currentPosition;

    if (currentPosition === Waypoint.inside && !this.props.impersonating && this.props.enableReadReceipts !== false) {
      // @ts-ignore TODO: Runtime require/import with Rollup? See: https://github.com/rollup/rollup/issues/1807
      var Visibility = require('visibilityjs');

      Visibility.onVisible(function () {
        _this.props.message.conversation.markConversationRead(_this.props.message.messageId);
      });
    }
  };

  MessageContainer.prototype.handleError = function (error) {
    throw new Error(error);
  };

  MessageContainer.prototype.render = function () {
    var _this = this;

    var client = this.props.chatClient;
    var myself = client && client.myself;

    if (!this.props.message.initialized || !myself) {
      // Not initialized, or the client isn't available, so don't render the message
      return null;
    }
    /**
     * This needs to follow a specific priority
     * 1. Custom message components (passed in prop)
     * 2. Rich card messages (defined enum)
     * 3. Core message types
     */


    var messageComponents = __spreadArrays(this.props.customMessageComponents, this.richCardMessages, this.coreMessages);

    var MessageComponent = messageComponents.find(function (handler) {
      return handler.handlesMessage(_this.props.message);
    });

    if (MessageComponent) {
      /**
       *  TODO: This <div> complicates styling, because it breaks the flexbox.
       *  See: MessageGroup/styles.css
       *  MessageRow assumes there is only one child. If this is no longer the case, MessageRow will need to be updated
       */
      var message = React__default.createElement("div", null, React__default.createElement(ScrollConsumer, null, function (_a) {
        var scrollToTarget = _a.scrollToTarget;
        return React__default.createElement(MessageRow, {
          message: _this.props.message,
          nextMessage: _this.props.nextMessage,
          nextMessageBySameParticipant: _this.props.nextMessageBySameParticipant
        }, React__default.createElement(MessageComponent, {
          message: _this.props.message,
          myself: myself,
          onError: _this.handleError,
          onLoaded: scrollToTarget
        }));
      }));

      if (this.state.isRead) {
        return message;
      } else {
        return React__default.createElement(Waypoint, {
          onPositionChange: this.handlePositionChange
        }, message);
      }
    } else {
      throw new Error('Unknown message type');
    }
  };

  return MessageContainer;
}(React__default.Component);

var Message = withChat(MessageContainer);

export default Message;
//# sourceMappingURL=index.js.map
